import useAuth from '@/hooks/useAuth';
import { useSearchParams } from '@/hooks/useSearchParams';
import { useUpdateUserMutation } from '@/queries/user.queries';
import timezoneService from '@/services/timezone.service';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

export default function useTimeZoneModal() {
	const { t } = useTranslation();
	const { getCurrentUser } = useAuth();
	const updateUserMutation = useUpdateUserMutation();
	const history = useHistory();
	const params = useSearchParams();

	return {
		isOpen: params.get('viewTzModal') === 'true',
		t,
		currentTimeZone: timezoneService.getTimeZone(),
		profileTimeZone: getCurrentUser().timeZone,
		handleChangeTimeZoneClick: () => {
			const timeZone = timezoneService.getTimeZone();
			updateUserMutation.mutateAsync({ timeZone }).then(() => {
				history.replace(history.location.pathname);
			});
		},
		handleCloseTimeZoneModalClick: () => history.replace(history.location.pathname),
	};
}
